import Component from 'vue-class-component';
import VueCqrs from '@cqrs/vue-component-cqrs';
import * as q from '@Alternatives/AlternativesLists/Domain/queries';

@Component
export default class AlternativesListsQueries extends VueCqrs
{
	runKanbanPageQueryV1(workspaceId: number, projectId: number, viewDefId: string | null)
	{
		const query = q.buildKanbanPageQueryV1(workspaceId, projectId, viewDefId);
		this.$query(query);
	}

	runGridPageQueryV1(workspaceId: number, projectId: number, viewDefId: string | null)
	{
		const query = q.buildGridPageQueryV1(workspaceId, projectId, viewDefId);
		this.$query(query);
	}

	runAlternativesListByProjectIdQueryV1(workspaceId: number, projectId: number)
	{
		const query = q.buildAlternativesListByProjectIdQueryV1(workspaceId, projectId);
		this.$query(query);
	}

	runRelationshipsByProjectIdQueryV1(workspaceId: number, projectId: number)
	{
		const query = q.buildRelationshipsByProjectIdQueryV1(workspaceId, projectId);
		this.$query(query);
	}

	runStatusDependenciesQueryV1(workspaceId: number, projectId: number, alternativesListId: number, statusId: number)
	{
		const query = q.buildStatusDependenciesQueryV1(workspaceId, projectId, alternativesListId, statusId);
		this.$query(query);
	}

	runAlternativesComparisonQueryV1(workspaceId: number, projectId: number, viewDefId: string | null, alternativeIds: string[], formId: number | null)
	{
		const query = q.buildAlternativesComparisonQueryV1(workspaceId, projectId, viewDefId, alternativeIds, formId);
		this.$query(query);
	}
}
